import { useHolidayTheme } from "@/hooks/use-holiday-theme";
import { HolidayParticles } from "./holiday-particles";
import { HolidayBanner } from "./holiday-banner";

/** Fixed overlay with floating emoji particles. Place once in the root layout. */
export function HolidayDecorations() {
  const holiday = useHolidayTheme();
  if (!holiday) return null;
  return <HolidayParticles holiday={holiday} />;
}

/** Dismissible greeting banner. Place inside the main content area. */
export function HolidayBannerSlot() {
  const holiday = useHolidayTheme();
  if (!holiday) return null;
  return <HolidayBanner holiday={holiday} />;
}
